<template>
  <select-options
    ref="select"
    :name="name"
    :options="options"
    :loading="loadingGroups"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { ioCompanyGroups } from '@/febos/servicios/api/empresas.api';
import SelectOptions from '@/febos/global/customDocuments/components/SelectOptions';

export default {
  name: 'select-groups',
  components: {
    SelectOptions,
  },
  data() {
    return {
      loadingGroups: false,
      opts: [],
    };
  },
  computed: {
    options() {
      return this.opts || [];
    }
  },
  methods: {
    async fetchGroups() {
      this.loadingGroups = true;
      try {
        const filters = [];
        if (this.onlyMyGroups) {
          filters.push(`usuarioId:${this.$store.getters['Usuario/currentUser'].id}`);
        }

        const { data: { grupos } } = await ioCompanyGroups(
          {
            empresaId: this.companyId,
            filtros: filters.filter((filter) => !!filter).join('|'),
          }
        );

        this.opts = grupos.map((group) => ({
          value: group.nombre,
          label: group.descripcion,
          ...(grupos.length === 1 && { default: true }),
        }));
      } finally {
        this.loadingGroups = false;
      }
    }
  },
  mounted() {
    this.fetchGroups();
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    onlyMyGroups: {
      type: Boolean,
      default: false
    },
  }
};
</script>
